import { create } from 'zustand';
import { RequestStatus } from '@/shared/model/requestStatus';
import { getErrorMessage } from '@/shared/lib/errors';
import { messageTemplateService } from '../api/messageTemplateService';
import type { MessageTemplateState } from './types';

let groupsRequest = 0;
let listRequest = 0;
let detailsRequest = 0;

const initialState = {
    groups: [],
    items: [],
    current: null,
    activeGroup: null,
    groupsStatus: RequestStatus.Idle,
    listStatus: RequestStatus.Idle,
    detailsStatus: RequestStatus.Idle,
    groupsError: null,
    listError: null,
    detailsError: null,
};

/** Хранит группы и выбранные текстовки */
export const useMessageTemplateStore = create<MessageTemplateState>((set) => ({
    ...initialState,

    fetchGroups: async () => {
        const request = ++groupsRequest;

        set({
            groups: [],
            groupsStatus: RequestStatus.Loading,
            groupsError: null
        });

        try {
            const groups = await messageTemplateService.getGroups();

            if (request !== groupsRequest) return;

            set({
                groups,
                groupsStatus: RequestStatus.Success
            });
        } catch (error: unknown) {
            if (request !== groupsRequest) return;

            set({
                groupsStatus: RequestStatus.Error,
                groupsError: getErrorMessage(error, 'Не удалось загрузить группы'),
            });
        }
    },

    fetchGroup: async (group) => {
        const request = ++listRequest;

        set({
            activeGroup: group,
            items: [],
            listStatus: RequestStatus.Loading,
            listError: null
        });

        try {
            const items = await messageTemplateService.getByGroup(group);

            if (request !== listRequest) return;

            set({
                items,
                listStatus: RequestStatus.Success
            });
        } catch (error: unknown) {
            if (request !== listRequest) return;

            set({
                listStatus: RequestStatus.Error,
                listError: getErrorMessage(error, 'Не удалось загрузить текстовки'),
            });
        }
    },

    fetchById: async (id) => {
        const request = ++detailsRequest;

        set({
            current: null,
            detailsStatus: RequestStatus.Loading,
            detailsError: null
        });

        try {
            const current = await messageTemplateService.getById(id);

            if (request !== detailsRequest) return;

            set({
                current,
                detailsStatus: RequestStatus.Success
            });
        } catch (error: unknown) {
            if (request !== detailsRequest) return;

            set({
                detailsStatus: RequestStatus.Error,
                detailsError: getErrorMessage(error, 'Не удалось загрузить текстовку'),
            });
        }
    },

    reset: () => {
        groupsRequest++;
        listRequest++;
        detailsRequest++;
        set(initialState);
    },
}));
